import React from 'react';
import styles from './Step.module.css';

export interface StepRenderProps {
  disabled: boolean;
  initiallySolved: boolean;
  storageKey: string;
  onSolved: () => void;
}

export interface StepProps {
  title: string;
  isUnlocked: boolean;
  isSolved: boolean;
  storageKey: string;
  solvedMessage?: string;
  onSolved: () => void;
  children: (injected: StepRenderProps) => React.ReactNode;
}

export const Step: React.FC<StepProps> = ({
  title,
  isUnlocked,
  isSolved,
  storageKey,
  solvedMessage,
  onSolved,
  children,
}) => {
  return (
    <div className="step">
      <h2 style={{ marginTop: 0 }}>{title}</h2>
      {!isUnlocked && !isSolved && (
        <div className={styles.lockedBanner} aria-hidden>
          Locked. Solve the previous step to unlock this one.
        </div>
      )}

      {children({
        disabled: !isUnlocked || isSolved,
        initiallySolved: isSolved,
        storageKey,
        onSolved,
      })}

      {isSolved && solvedMessage && (
        <div style={{ marginTop: 10, fontSize: 18 }}>{solvedMessage}</div>
      )}
    </div>
  );
};

export default Step;


